import React from 'react';
import ControlsArrowsPrevious from './ControlsArrowsPrevious';
const ControlsArrowsPreviousXS = ({ color, ...props }) => (React.createElement(ControlsArrowsPrevious, Object.assign({ color: color, size: 16 }, props)));
ControlsArrowsPreviousXS.displayName = 'ControlsArrowsPreviousXS'; // Fix for tsc
export default ControlsArrowsPreviousXS;
//# sourceMappingURL=ControlsArrowsPreviousXS.js.map